import type { JSX } from 'react';
import type { WireArtifact } from '@logistics/contracts';
import { clockTime, monthDay } from '@/lib/format';

type Chat = Extract<WireArtifact, { kind: 'chat' }>;

/** The thread oldest first, one card per message — the mail thread's look. */
export function ChatArtifact({ artifact }: { artifact: Chat }): JSX.Element {
  return (
    <div className="flex flex-col gap-2.5">
      {artifact.truncated && (
        <p className="text-mute text-xs">
          Showing the last {artifact.messages.length}; the thread is longer.
        </p>
      )}
      {artifact.messages.map((m, i) => (
        <div key={i} className="border-line bg-surf rounded-xl border px-4 py-3.5">
          <div className="flex items-baseline justify-between gap-2.5">
            <span className="min-w-0 truncate text-[13.5px] font-medium">
              {m.sender ?? 'Unknown sender'}
            </span>
            <span className="text-mute font-mono text-[10.5px] whitespace-nowrap">
              {monthDay(m.at)}, {clockTime(m.at)}
            </span>
          </div>
          {m.text !== undefined && (
            <div className="mt-1.5 text-[13px] leading-[1.55] whitespace-pre-wrap [overflow-wrap:anywhere]">
              {m.text}
            </div>
          )}
        </div>
      ))}
      {artifact.messages.length === 0 && (
        <p className="text-mute text-[13px]">No messages in this thread.</p>
      )}
    </div>
  );
}
